<script type="text/ecmascript-6">
    export default {
        props: ['pageditems', 'filter', 'dataurl', 'loading'],

        computed: {
            activeFilters: function() {
                return _.pickBy(this.filter, function(value, key) {
                    if (key == 'page') {
                        return value != 1;
                    }
                    return value != null;
                })
            }
        },

        methods: {
            fetchItems: function () {
                window.location.href = this.dataurl+'?' + $.param( this.activeFilters ? this.activeFilters : this.filter );
            },
            previousPage: function () {
                Vue.set(this.filter, 'page', this.pageditems.current_page - 1);

                this.fetchItems();
            },
            nextPage: function () {
                Vue.set(this.filter, 'page', this.pageditems.current_page + 1);

                this.fetchItems();
            }
        }
    }
</script>
<template>
    <div class="table-pager-simple">
        <ul v-if="pageditems.total > 0 && pageditems.last_page > 1" class="pager pull-right">
            <li :class="['previous', pageditems.current_page == 1 ? 'disabled' : '']">
                <a @click="pageditems.current_page == 1 ? null : previousPage()"><span
                        aria-hidden="true">&larr;</span> Previous</a>
            </li>
            <li :class="['next', pageditems.current_page == pageditems.last_page ? 'disabled' : '']">
                <a @click="pageditems.current_page == pageditems.last_page ? null : nextPage()">Next
                    <span aria-hidden="true">&rarr;</span></a>
            </li>
        </ul>
    </div>
</template>
<style>
</style>